import { preloadableLazy } from '@/util/preloadable-lazy'

/** Login is eager — cold open must not wait on a Suspense chunk. */
export { default as ViewLogin } from '@/pages/login'

/** Single lazy instances so hover/idle preload and the router share the same chunk promise. */
export const ViewSignup = preloadableLazy(() => import('@/pages/signup'))
export const ViewDeposit = preloadableLazy(() => import('@/pages/deposit'))
export const ViewWithdraw = preloadableLazy(() => import('@/pages/withdraw'))
